import { rootConfig } from 'config/routeConfigurations/rootConfig/rootConfig';
import { dashboardConfig } from 'config/routeConfigurations/dashboardConfig/dashboardConfig';
import qs, { BooleanOptional, IStringifyOptions } from 'qs';

export class AppRoutes {
    // ========= Root Routes =========
    static readonly DASHBOARD = rootConfig.dashboard.link;
    static readonly SETTINGS = rootConfig.settings.link;
    static readonly MOBILE = rootConfig.mobile.link;

    // ========= Dashboard Sub-Routes =========
    static readonly PROJECT = dashboardConfig.project.link;
    static readonly PORTFOLIO = dashboardConfig.portfolio.link;
    static readonly EXCELLENCE_APPS = dashboardConfig.excellenceApps.link;

    // ========= Composed Dashboard Paths =========
    static get DASHBOARD_PROJECT_PATH(): string {
        return this.buildPath(this.DASHBOARD, this.PROJECT);
    }

    static get DASHBOARD_PORTFOLIO_PATH(): string {
        return this.buildPath(this.DASHBOARD, this.PORTFOLIO);
    }

    static get DASHBOARD_EXCELLENCE_APPS_PATH(): string {
        return this.buildPath(this.DASHBOARD, this.EXCELLENCE_APPS);
    }

    /**
     * buildPath examples:
     * 1) AppRoutes.build('/new-path', 'details', 123);
     * → "/new-path/details/123"
     *
     * 2) AppRoutes.build('new-path/', '/details/', '/123/');
     * → "/new-path/details/123"
     *
     * 3) const detailPath = AppRoutes.build(AppRoutes.DASHBOARD_PROJECT_PATH, 'details', projectId);
     * → "/dashboard/project/details/123"
     */
    static buildPath(...segments: (string | number | null | undefined)[]): string {
        const cleaned = segments
            .filter(Boolean)
            .map((s) => String(s).replace(/^\/+|\/+$/g, '')) // trim slashes
            .join('/');

        return '/' + cleaned;
    }

    //TODO: Should be tested
    static buildPathWithQuery = (
        segments: (string | number | null | undefined)[],
        query: any,
        qsOptions?: IStringifyOptions<BooleanOptional>,
    ): string => {
        const base = this.buildPath(...segments);
        if (!query || Object.keys(query).length === 0) return base;

        const queryString = qs.stringify(query, {
            addQueryPrefix: true,
            skipNulls: true,
            ...qsOptions,
        });

        return `${base}${queryString}`;
    };
}
